export const isValidPreviousPath = (path: string | undefined): boolean => {
    if (!path) {
        return false;
    }

    const parts = path.split('/');
    if (parts.length === 0) {
        return false;
    }

    const lastPart = parts[parts.length - 1];
    if (lastPart === 'login' || lastPart === 'register' || lastPart === 'forgot-password' || lastPart === 'switch-account') {
        return false;
    }

    return true;
};
